<div
  class="add-to-cart-button-group"
  [matTooltipDisabled]="!disabled"
  [matTooltip]="_disabledTooltip"
>
  <ng-container [ngSwitch]="mode">
    <ng-container *ngSwitchCase="'with-controls'" [ngTemplateOutlet]="WITH_CONTROLS"></ng-container>
    <ng-container *ngSwitchCase="'controls-only'" [ngTemplateOutlet]="CONTROLS_ONLY"></ng-container>
    <ng-container *ngSwitchDefault [ngTemplateOutlet]="NO_CONTROLS"></ng-container>
  </ng-container>

  <ng-template #WITH_CONTROLS>
    <div class="with-controls">
      <div class="controls">
        <button
          mat-button
          [color]="buttonColor"
          class="remove-button control"
          [xButtonSize]="buttonSize"
          (click)="decreaseTotal()"
        >
          -
        </button>

        <div class="quantities" [class.loading]="loading">
          <div class="current-quantity">{{ itemCount }}</div>
        </div>

        <button
          mat-button
          [color]="buttonColor"
          class="add-button control"
          [xButtonSize]="buttonSize"
          (click)="increaseTotal()"
        >
          <span>+</span>
        </button>
      </div>

      <button
        mat-flat-button
        [color]="buttonColor"
        class="add-all-button"
        [xButtonSize]="buttonSize"
        [disabled]="disabled"
        (click)="addAllItems()"
        [xButtonLoading]="loading"
        loaderType="dot-flashing"
        loaderTheme="light"
        loaderSize="small"
      >
        {{ this.label }}
      </button>
    </div>
  </ng-template>

  <ng-template #NO_CONTROLS>
    <div class="no-controls" [class.show-quantity-diff]="pendingQuantity > 0">
      <ng-container *ngTemplateOutlet="MAIN_CTA; context: { $implicit: 'light' }"></ng-container>
      <div class="diff-quantity">
        {{ pendingQuantity > 0 ? '+' + pendingQuantity : '' }}
      </div>
    </div>
  </ng-template>

  <ng-template #CONTROLS_ONLY>
    <div class="controls-only">
      <div class="controls">
        <button
          mat-flat-button
          [color]="buttonColor"
          class="remove-button control"
          [xButtonSize]="buttonSize"
          (click)="remove()"
        >
          <span class="control-text">-</span>
        </button>

        <div class="label" [class.loading]="loading">
          <ng-container *ngIf="pendingQuantity === 0; else ELSE">
            <div class="current-quantity">{{ quantityControl.value }}</div>
            <div
              *ngIf="showControlLabel"
              class="label-text add-line-height text-truncate"
              i18n="@@Product.InBag"
            >
              In bag
            </div>
          </ng-container>

          <ng-template #ELSE>
            <div class="current-quantity">
              {{ quantityControl.value + pendingQuantity }}
            </div>
            <div *ngIf="showControlLabel" class="label-text text-truncate" i18n="@@Product.ToBag">
              <ng-container>to bag</ng-container>
            </div>
          </ng-template>
        </div>

        <button
          mat-flat-button
          [color]="buttonColor"
          class="add-button control"
          [xButtonSize]="buttonSize"
          (click)="add()"
        >
          <span class="control-text">+</span>
        </button>
      </div>

      <x-loader
        loader="dot-flashing"
        theme="dark"
        size="small"
        [opacity]="0"
        *ngIf="loading"
      ></x-loader>
    </div>
  </ng-template>
</div>

<ng-template #MAIN_CTA let-loaderTheme>
  @switch (this.buttonType) {
    @case ('stroked') {
      <button
        mat-stroked-button
        class="add-button"
        loaderType="dot-flashing"
        loaderTheme="dark"
        loaderSize="small"
        [color]="buttonColor"
        [class.show-quantity]="pendingQuantity > 0"
        [xButtonSize]="buttonSize"
        [disabled]="disabled"
        (click)="add()"
        [xButtonLoading]="loading"
      >
        {{ this.label }}
      </button>
    }
    @default {
      <button
        mat-flat-button
        class="add-button"
        loaderType="dot-flashing"
        [loaderTheme]="loaderTheme ?? 'dark'"
        loaderSize="small"
        [color]="buttonColor"
        [class.show-quantity]="pendingQuantity > 0"
        [xButtonSize]="buttonSize"
        [disabled]="disabled"
        (click)="add()"
        [xButtonLoading]="loading"
      >
        {{ this.label }}
      </button>
    }
  }
</ng-template>
